import {TIME_LINE} from './timeline'
import * as _ from 'underscore'
import {Vector2} from 'three'
import {getPanoPosition} from './panorama/utils'

class TimeLineMana {
  constructor (video_, markers_) {
    this.markers = markers_
    this.dom = video_
    this.totalTime = 0
    this.curTime = 0
    this.bindTimes()
    this.addEvents()

    this.enterframe()
  }

  /**   * 刷新   */
  enterframe = () => {
    requestAnimationFrame(this.enterframe)
    if(!this.dom) return;
    if (this.dom.paused) return
    this.updateMarkers(this.dom.currentTime)
  }

  // step1 ：全景内添加所有标记，并且隐藏  visible
  // step2 ：获取视频总时长
  // step3 : 关联时间轴 与对应的 marker
  // step4 : 视频进度变动时 查询每个 timeLine.timeItem 是否处于显示时间段
  // step5 : 如果 timeItem处于显示时间段时， 求出 timeItem的持续时间
  // step6 : 根据inPos 入场位置，  endPos计算 该元素在该时间轴片段的移动距离
  // step7 : 根据 移动距离 除以 元素 移动距离 /（endTime - inTime） = 每秒移动距离
  // step8 : 根据 当前时间 计算 该timeLine 进度  求出 元素具体显示位置

  bindTimes () {
    // 舞台
    let stageVec2 = new Vector2(4096, 2048)
    let half = new Vector2()
    half.x = stageVec2.x / 2
    half.y = stageVec2.y / 2

    // 标视频点位时坐标
    let pMVec2 = new Vector2(1920, 960)

    // 计算标记比例尺
    let wRatio = pMVec2.x / stageVec2.x
    let hRatio = pMVec2.y / stageVec2.y

    TIME_LINE.map((timeItem) => {
      let tempMarker = _.find(this.markers, {panoID: timeItem.id})
      timeItem.marker = tempMarker
      timeItem.time.map(subItme => {
        // 转换比例尺
        subItme.inPos.x /= wRatio
        subItme.inPos.y /= hRatio

        subItme.endPos.x /= wRatio
        subItme.endPos.y /= hRatio
        // 求持续时间
        let totalTime = subItme.endTime - subItme.inTime
        // 求运动距离
        let inVec = new Vector2(subItme.inPos.x, subItme.inPos.y)
        let endVec = new Vector2(subItme.endPos.x, subItme.endPos.y)
        subItme.moveTotal = new Vector2()
        subItme.moveTotal.x = endVec.x - inVec.x
        subItme.moveTotal.y = endVec.y - inVec.y

        // 求圆最最短路径
        // getVecMinMove(inVec.x, endVec.x, stageVec2.x)

        // 计算每秒移动的距离
        subItme.moveStep = subItme.moveTotal.clone()
        subItme.moveStep.x /= totalTime
        subItme.moveStep.y /= totalTime

      })
    })
  }

  updateMarkers (time) {
    let that = this
    this.getShowMarkers(time)
  }

  /* 判断元素是否显示 */
  getShowMarkers (time) {
    time *= 1000
    let that = this

    // 舞台尺寸
    let pw = 4096
    let ph = 2048

    let shows = []// 需要显示的元素
    // 遍历时间轴
    TIME_LINE.map(timeItem => {
      // 获取标记
      let tempMarker = _.find(that.markers, {panoID: timeItem.id})
      let show = false
      let showFrame = null
      timeItem.time.map(subItem => {
        // 该元素已经在出场时间段内
        if (time > subItem.inTime && time < subItem.endTime) {
          showFrame = subItem
          show = true
        }
      })
      tempMarker.visible = show
      if (show) {

        // 移动元素位置
        let moveTime = time - showFrame.inTime// 该步骤已进行多长时间
        let moveVec = showFrame.moveStep.clone().multiplyScalar(moveTime)
        moveVec.x += showFrame.inPos.x
        moveVec.y += showFrame.inPos.y
        let moveVec3 = getPanoPosition(moveVec.x, moveVec.y, pw, ph, 1)
        // 将求出来的坐标 赋予 显示元素
        tempMarker.position.copy(moveVec3)
        shows.push(tempMarker)
      }
    })
  }

  addEvents () {
    let that = this
    this.dom.addEventListener('load', (e) => {
      that.totalTime = that.dom.duration
    })
    // this.dom.addEventListener('timeupdate', (e) => {
    //   that.updateMarkers(that.dom.currentTime)
    // })
  }
}

export {TimeLineMana}



// WEBPACK FOOTER //
// ./src/webgl/TimeLineMana.js